import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import cx from "classnames";
import _ from "lodash";
import shortid from "shortid";
import { Button, Modal } from "react-bootstrap";

import { AssetManager } from "components/AssetManager";

import styles from "./manualManager.module.scss";
import { createJourneyStep, updateJourneyStep } from "actions/journey";

const ManualManager = ({show, onClose, journeyId, selectedNode}) => {
  const dispatch = useDispatch();

  const steps = useSelector(state => _.get(state, `journey.${journeyId}.steps`) || []);
  const content = _.find(steps, function (step) {
    return step.uid == selectedNode || step.id == selectedNode ;
  });
  const existingNode = _.some(steps, function (step) {
    return step.id === selectedNode;
  });
  const mapping = _.get(content, 'mapping') || null;

  const onFinish =(selectedAsset)=> {
    var contentStepRequest = {
      id: journeyId,
      mapping: selectedAsset[0].id,
      type: "CONTENT",
    }

    if (!mapping && !existingNode ) {
      dispatch(createJourneyStep(journeyId, selectedNode, contentStepRequest));
    } else {
      dispatch(updateJourneyStep(journeyId, selectedNode, contentStepRequest));
    }

    onClose()
  }


  return (
    <Modal
      show={show}
      className={styles.assetManagerContainer}
      backdropClassName={styles.backdrop}
      centered
    >
      <AssetManager
        show={show}
        selected={mapping}
        onFinish={onFinish}
        multiple={false}
        onClose={onClose}
      />
    </Modal>
  );
};

export default ManualManager;
